export enum IntervalTab {
  Day = "day",
  Week = "week",
  Month = "month",
  Year = "year",
}

export const allIntervalTabs: IntervalTab[] = [IntervalTab.Day, IntervalTab.Week, IntervalTab.Month, IntervalTab.Year];
